import styled from '@emotion/styled';
import Loader from 'components/Kizen/Loader';

export const StyledLoader = styled(Loader)`
  position: fixed;
  left: 0;
  right: var(--app-inset-right, 0px);
  top: 0;
  bottom: 0;
  z-index: 9999;
  background: var(--color-background-white);
`;
